import Service from '@ember/service';
import { getOwner } from '@ember/application';
// Importing from -private is a workaround until
// https://github.com/typed-ember/ember-cli-typescript/issues/790 is resolved.

// Engines do not have a `router` service which is normally provided by Ember
// in regular applications. The router service is the preferred way to call
// transition routes without a page link.
//
// This service emulates that functionality until engines also get a router
// service provided.
//
export default class ApplicationRouter extends Service {
  generateUrl(...args) {
    return this._commonRoute._router.generate(...args);
  }
  transitionTo(...args) {
    return this._commonRoute.transitionTo(...args);
  }
  replaceWith(...args) {
    return this._commonRoute.replaceWith(...args);
  }
  transitionToExternal(...args) {
    return this._commonRoute.transitionToExternal(...args);
  }
  replaceWithExternal(...args) {
    return this._commonRoute.replaceWithExternal(...args);
  }
  refresh(routeName) {
    return getOwner(this).lookup(`route:${routeName}`).refresh();
  }
  get currentRouteName() {
    return this._commonRoute.currentRouteName;
  }
  get _commonRoute() {
    // 'route:basic' is undocumented but injected everywhere
    // https://github.com/emberjs/ember.js/blob/v5.5.0/packages/@ember/application/index.ts#L1204
    return getOwner(this).lookup('route:basic');
  }
}